import Reader from './Reader.vue';

export default Reader;
